import React from "react";
import { PartnerContent } from "../Models/PartnerContentModel";

const PartnerContentContext = React.createContext(new PartnerContent());

export default PartnerContentContext;
